import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addDiscountCode, setDiscountCodeError } from "redux/actions/checkout";

const useAutoApplyDiscountCode = () => {
  const dispatch = useDispatch();
  const { cart, discountCode, isClaimed, isLoggedIn } = useSelector((s) => ({
    ...s.checkout,
    ...s.auth,
  }));

  const attemptedCode = useRef(null);

  const hasCart = Boolean(cart);
  const hasDiscount = Boolean(cart && cart.discount);

  useEffect(() => {
    if (!discountCode || !hasCart) return;
    if (hasDiscount) return;
    if (isLoggedIn && !isClaimed) return;
    if (attemptedCode.current === discountCode) return;

    attemptedCode.current = discountCode;

    dispatch(addDiscountCode(discountCode)).then(
      () => {},
      (err) => {
        const message =
          err?.response?.data?.error?.message ||
          "We couldn't apply that discount code.";
        dispatch(setDiscountCodeError(message));
      },
    );
  }, [discountCode, hasCart, hasDiscount, isClaimed, isLoggedIn, dispatch]);
};

export default useAutoApplyDiscountCode;
